export default function jump (url) {
  window.location = url
}
